import { render, staticRenderFns } from "./BetgameReset.vue?vue&type=template&id=9def3c30&scoped=true"
import script from "./BetgameReset.vue?vue&type=script&lang=js"
export * from "./BetgameReset.vue?vue&type=script&lang=js"
import style0 from "./BetgameReset.vue?vue&type=style&index=0&id=9def3c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9def3c30",
  null
  
)

export default component.exports